module.exports = __webpack_public_path__ + "img/grad-3.15d11b5f.svg";